import React from 'react';
import { Component } from "react";
import { API_URL } from '../urls';
import DefaultLayout from "../layouts/Default";
require('odatajs');

class ProductPageViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      pending: true,
      data: null,
      params: props.match.params
    };
  }

  componentDidMount() {
    document.title = "Product page";

    let token = localStorage.getItem('_TOKEN_AUTH');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
    var request = {
        requestUri: API_URL + "Products?$filter=Name eq '" + encodeURIComponent(this.state.params.product_name) + "'"
        + "&$expand=Pages($filter=Name eq '" + encodeURIComponent(this.state.params.page_name) + "')",
        method: 'GET',
        headers: headers
    };
    window.odatajs.oData.request(
        request,
        (data, response) => {
          	this.setState({
	            pending: false,
        	    data
	        });
            },
            (error) => {
                if(error.response.statusCode === 401){
                  window.location.href = "/user/login";
                }
          	this.setState({
	            pending: false,
        	    error
	        });
            }
        );
    }
    render() { 
	const { error, pending, data } = this.state;
	if (error) {
      		return <div>Error: {error.message}</div>;
	} else if (pending) {
		return <div>Loading...</div>;
	} else {
	        return (
<DefaultLayout>
  <div dangerouslySetInnerHTML={{ __html: data.value[0].Pages[0].Body }} />
</DefaultLayout>
		);
	}
    }
}
 
export default ProductPageViewPage;